import React from "react";
import { useImmer } from "use-immer";

import {
  ColorDisabled,
  ColorError,
  ColorSuccess,
  ColorWarning,
  IgPaper,
  IgTypography,
} from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { SxProps } from "@mui/system";

import { SkeletonGroup } from "../../../../../../components/Utils/SkeletonGroup";

import { ScheduleContent } from "./ScheduleContent";
import { StatusContent } from "./StatusContent";
import { PanelProps } from "./types";

const sxProps: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  boxShadow: "unset",
  padding: "15px",
  minHeight: "40px",
  borderRadius: "10px",
  marginLeft: "10px",
  marginRight: "10px",
};

const Loading = ({ label }: { label: string }) => {
  return (
    <Grid container columnSpacing={2} alignItems={"center"}>
      <Grid item>
        <IgTypography sx={{ fontWeight: 600 }}>{label} at:</IgTypography>
      </Grid>
      <Grid item sx={{ width: "80%" }}>
        <SkeletonGroup lines={2} />
      </Grid>
    </Grid>
  );
};
export const BasePanel = (props: PanelProps) => {
  const [isScheduling, setIsScheduling] = useImmer<boolean>(false);

  return (
    <IgPaper
      elevation={0}
      sx={{
        ...sxProps,
        borderColor: props.disabledReason
          ? ColorDisabled.main
          : props.color === "success"
            ? ColorSuccess.main
            : props.color === "warning"
              ? ColorWarning.main
              : ColorError.main,
      }}
    >
      {props.isLoading ? (
        <Loading label={props.label} />
      ) : isScheduling ? (
        <ScheduleContent {...props} setIsScheduling={setIsScheduling} />
      ) : (
        <StatusContent {...props} setIsScheduling={setIsScheduling} />
      )}
    </IgPaper>
  );
};
